import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ConfimationPopupComponent} from './confimation-popup.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TranslateModule } from '@ngx-translate/core';
@NgModule({
  declarations: [ConfimationPopupComponent],
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    TranslateModule.forChild()
  ],
  exports: [ConfimationPopupComponent]
})
export class ConfirmationpopupModule { }
